import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import PageLoading from './PageLoading'

const TableLoading = ({ loading, colSpan }) => loading
  ? (
  <TableRow>
    <TableCell colSpan={colSpan}>
      <PageLoading loading={loading} />
    </TableCell>
  </TableRow>
    )
  : <></>

export default TableLoading
